import {CrmLayoutBar} from "../../../../LayoutCrm";
import React, {Component} from 'react';
import {APIClient} from "../../../../utils/APIClient";
import {API_URL} from "../../../../settings/local_settings";
import SellLeadModal from "./SellLeadModal";
import LeadDetailMainInfo from "./LeadDetailMainInfo";
import LeadGoogleAdsInfo from "./LeadGoogleAdsInfo";
import LeadNotesSection from "./LeadNotesSection";
import LeadDetailHeader from "./LeadDetailHeader";
import {LocalStorage} from "../../../../utils/LocalStorage";
import {withRouterParams} from "../../../../utils/withRouterParams";
import { withTranslation } from "react-i18next";

class LeadDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            leadData: null,
            amountModalIsOpen: false,
            addNoteModalIsOpen: false
        };

        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleLeadSoldSubmit = this.handleLeadSoldSubmit.bind(this);
        this.submitLeadStateChange = this.submitLeadStateChange.bind(this);
        this.openAmountModal = this.openAmountModal.bind(this);
        this.updateNotes = this.updateNotes.bind(this);
    }

    componentDidMount() {
        this.fetchLeadData();
    }

    // URLS

    crmApiURL() {
        return `${API_URL}${this.crmApiPath()}`;
    }

    crmApiPath() {
        let clientId;
        if (LocalStorage.hasUserClientId()) {
            clientId = LocalStorage.fetchUserClientId();
        } else {
            clientId = this.props.match.params.clientId;
        }
        return `crm/${clientId}`;
    }

    crmFrontPath() {
        let clientId;
        if (this.props.match.params.hasOwnProperty('clientId')) {
            clientId = this.props.match.params.clientId;
            return `crm/${clientId}`;
        } else {
            return `crm`;
        }
    }


    fetchLeadData() {
        new APIClient(`${this.crmApiURL()}/lead/${this.props.match.params.id}`).call('GET').then((response) => {
           if (response.status === 'ERROR') {
               alert(response.error_message);
           } else {
               const leadData = {
                   firstName: response.data.first_name,
                   lastName: response.data.last_name,
                   firstContact: response.data.submitted_on,
                   phoneNumber: response.data.phone_number,
                   email: response.data.email,
                   campaign: response.data.campaign,
                   adgroup: response.data.ad_group,
                   keyword: response.data.keyword,
                   message: response.data.message,
                   landingUrl: response.data.landing_url,
                   extraFields: response.data.extra_fields,
                   state: response.data.state,
                   saleAmount: response.data.sale_amount || '',
                   notes: response.data.notes
               };
               this.setState({
                   leadData: leadData
               });
           }
        });
    }

    handleStateChange(event) {
        const target = event.target;
        const leadState = target.value;
        if (leadState === 'WON') {
            this.openAmountModal();
        } else {
            this.submitLeadStateChange({'state': leadState.toUpperCase()});
        }
    }

    handleLeadSoldSubmit(leadId, saleAmount) {
        this.closeAmountModal();
        let changeData = {'state': 'WON'};
        if (saleAmount !== '') {
            changeData['sale_amount'] = saleAmount
        }
        this.submitLeadStateChange(changeData)
    }

    submitLeadStateChange(changeData) {
        let submit_url = `${this.crmApiURL()}/lead/${this.props.match.params.id}/state`;
        new APIClient(submit_url).call('PUT', changeData).then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                const leadData = {
                    ...this.state.leadData,
                    state: changeData.state,
                    saleAmount: changeData.sale_amount || ''
                };

                this.setState({
                    leadData: leadData
                })

            }
        })
    }

    openAmountModal() {
        this.setState({
            amountModalIsOpen: true
        })
    }

    closeAmountModal() {
        this.setState({
            amountModalIsOpen: false
        })
    }

    render() {
        const { t } = this.props;
        if (this.state.leadData !== null) {
            return (
                <div className="app-content">
                    <CrmLayoutBar crmFrontPath={this.crmFrontPath()}/>
                    <section className="crm-section-content lead-detail">
                        <LeadDetailHeader leadData={this.state.leadData} onStateChange={this.handleStateChange}/>
                        {this.renderSellLeadModal()}
                        <div className="lead-detail-content">
                            <div className="detail-column">
                                <LeadDetailMainInfo leadData={this.state.leadData}/>
                                <LeadGoogleAdsInfo leadData={this.state.leadData}/>
                            </div>
                            <div className="detail-column">
                                <LeadNotesSection onNoteAdd={this.updateNotes} leadData={this.state.leadData}
                                                  leadId={this.props.match.params.id}
                                                  crmApiURL={this.crmApiURL()}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            )
        } else {
            return <p>{t('loading')}</p>
        }
    }

    renderSellLeadModal() {
        return <SellLeadModal onSubmit={this.handleLeadSoldSubmit} open={this.state.amountModalIsOpen}
                              leadId={this.props.match.params.id}/>;
    }

    updateNotes(newNote) {
        const leadNotes = [newNote].concat(this.state.leadData.notes);
        const leadData = {
            ...this.state.leadData,
            notes: leadNotes
        };
        this.setState({
            leadData: leadData
        });
    }
}

export default withRouterParams(withTranslation()(LeadDetail));